// extracted by mini-css-extract-plugin
export default {"thumbsContainer":"WUl2AHGnIXYXt4xXFTVS","fixedDimensions":"EPdPnAnpuXJMJbqL6QtV"};